// Version : 0.0.1
// Author :
// LastEdit : VISHAL BHARATHI
// Last ADD : UNNECESSARY PARTS REMOVED
// MODIFIED DATE: 19-09-2025

const WalletReportActionTypes = {
	/******************* FETCH GROUP MEMBER START ******************************** */
	FETCH_GROUP_MEMBER_START: 'fetch_group_member_start',
	FETCH_GROUP_MEMBER_SUCCESS: 'fetch_group_member_success',
	FETCH_GROUP_MEMBER_FAILURE: 'fetch_group_member_failure',
	FETCH_GROUP_MEMBER_RESPONSE_RESET: 'fetch_group_member_response_reset',
	FETCH_GROUP_MEMBER_RESPONSE_CHANGED: 'fetch_group_member_response_changed',
	/******************* FETCH GROUP MEMBER END ******************************** */

	/******************* FETCH WALLET REPORT START  ******************************** */
	FETCH_WALLET_REPORT_START: 'fetch_wallet_report_start',
	FETCH_WALLET_REPORT_SUCCESS: 'fetch_wallet_report_success',
	FETCH_WALLET_REPORT_FAILURE: 'fetch_wallet_report_failure',
	FETCH_WALLET_REPORT_RESPONSE_RESET: 'fetch_wallet_report_respons_reset',
	FETCH_WALLET_REPORT_RESPONSE_CHANGED: 'fetch_wallet_report_response_changed',
	/******************* FETCH WALLET REPORT END  ******************************** */
};
export default WalletReportActionTypes;
